//#region Libraries
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import EmptyView from "views/components/EmptyView/EmptyView";
import Preloader from "components/Preloader/Preloader";
import ScheduleComponent from "./components/SchedulesComponent/SchedulesComponent";
import CardLinkItemV2 from "components/CardLinkItem/secondary/CardLinkItemV2Mod";
//#endregion
//#region Icons
import CalendarIcon from "icons/CalendarIcon";
import ClipboardIcon from "icons/ClipboardIcon";
import EmployabilityIcon from "icons/EmployabilityIcon";
//#endregion
//#region Services
import { requestUserHasAssociatedAppointments } from "services/appointment/aboutAppoinment";
import { getUserId } from "services/storage/general";
//#endregion
//#region Utils
import { USER_ROLES } from "config/userPermissions";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useMainContext from "utils/context/useMainContext";
//#endregion
//#region Styles
import styled from "styled-components";

const CardLink = styled(CardLinkItemV2)`
    &.secondary {
        border: none;
    }
`;

// requestUserHasAssociatedAppointments
export const AppointmentSchedules = ({
    userRole,
}) => {
    const mainContext = useMainContext();
    const navigate = useNavigate();

    const BUTTON_PROPS_FOR_EMPTY_VIEW = {
        props: {
            text: "Crear asesoría",
            icon: <CalendarIcon/>,
        },
        to: ABSOLUTE_PATHS.APPOINTMENT_PSICOLOGICAS_CREATE
    };
    //#region States
    const [currentUserHasAppointments, setCurrentUserHasAppointments] = useState(null);
    const [fatalError, setFatalError] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        verifyIfCurrentUserHasAppointments();
    }, [userRole]);
    useEffect(() => {
        if (!fatalError || mainContext.showDialogUnexpectedError) return;
        navigate(ABSOLUTE_PATHS.HOME);
    }, [mainContext.showDialogUnexpectedError]);
    //#endregion
    //#region Functions
    const verifyIfCurrentUserHasAppointments = async () => {
        if (!userRole) return;
        const userId = getUserId();
        if (!userId) return;
        const hasAppointments = await requestUserHasAssociatedAppointments();
        if (hasAppointments !== null) {
            setCurrentUserHasAppointments(hasAppointments);
            return;
        }
        setFatalError(true);
        mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    const isAppointmentCoordinator = userRole !== USER_ROLES.ASESORIAS_PSICOLOGO;
    return (
        <>
            <HelmetUTP title="Asesoría"/>
            <Preloader 
                message="Cargando..." 
                hidden={currentUserHasAppointments !== null || fatalError}/>
            {currentUserHasAppointments !== null && 
                (currentUserHasAppointments
                ? <ScheduleComponent userRole={userRole}/>
                : <EmptyView
                    isCoordinator={isAppointmentCoordinator}
                    buttonProps={BUTTON_PROPS_FOR_EMPTY_VIEW}
                    as="psicólogo"/>)}
        </>
    );
}

const Appointments = (props) => {
    const { userRole } = props

    return <div style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '25px',
        paddingLeft: '32px',
        gap: '40px'
    }}>
        <h2 style={{margin: 0}}>Asesorías</h2>
        <div style={{ display: "flex", gap: "14px", maxHeight: "176px", maxWidth: "414px" }}>
            <CardLink variant="secondary" icon={<ClipboardIcon />} to="psicologicas" title="Psicologicas" description="Aspectos familiares, habilidades sociales, rendimiento académico y temas personales a tratar." />
            <CardLink variant="secondary" icon={<EmployabilityIcon />} to="empleabilidad" title="Empleabilidad" description="Herramientas para proceso de selección laboral, bolsa de trabajo, imagen personal, estructura de un CV." />
        </div>
    </div>
}

export default Appointments;
